import { wixSdk } from '@wix/js-sdk-wrapper/creator';
import ngSanitize from 'angular-sanitize';
import { wixSdkModule } from '../../shared/services/wixSdk/wixSdk.module';
import { getLocale } from '../../shared/utils/wix/getLocale';
import { dynamicStyleModule } from './components/DynamicStyle/DynamicStyle.module';
import { experimentLoaderModule } from './components/ExperimentLoader/ExperimentLoader.module';
import { widgetModule } from './components/Widget/Widget.module';
import { bitApiModule } from './services/bitApi/bitApi.module';
import { eventsServiceModule } from './services/eventsService/eventsService.module';
import { limitServiceModule } from './services/limitService/limitService.module';
import { schemaServiceModule } from './services/schemaService/schemaService.module';
import { socialServiceModule } from './services/socialService/socialService.module';
import { wixModule } from './services/wix/wix.module';

angular
  .module('bit.widget', [
    ngSanitize,

    'pascalprecht.translate',
    'tmh.dynamicLocale',

    wixSdkModule.name,
    widgetModule.name,
    dynamicStyleModule.name,
    bitApiModule.name,
    eventsServiceModule.name,
    limitServiceModule.name,
    schemaServiceModule.name,
    socialServiceModule.name,
    wixModule.name,
    experimentLoaderModule.name,
    'wmpcp.widgets.scroll-pane',
  ])
  .config(function translationConfig(
    $translateProvider,
    tmhDynamicLocaleProvider,
  ) {
    $translateProvider.useStaticFilesLoader({
      prefix: '../assets/locale/widget/widget_',
      suffix: '.json',
    });
    const fallbackLanguage = 'en';
    const preferredLanguage = getLocale();

    $translateProvider.preferredLanguage(preferredLanguage);
    $translateProvider.fallbackLanguage(fallbackLanguage);

    tmhDynamicLocaleProvider.localeLocationPattern(
      'https://static.parastorage.com/unpkg/angular-i18n@1.5.11/angular-locale_{{locale}}.js',
    );
    tmhDynamicLocaleProvider.defaultLocale(preferredLanguage);

    $translateProvider.useSanitizeValueStrategy('escapeParameters');
  });
